import React from 'react'

function MenuOption(props) {
    return (
        <wired-item style={{ pointerEvents: "none", margin: "auto"  }} class="frame-component MenuOption">Menu Item</wired-item>
    )
}
export default MenuOption